import { render, staticRenderFns } from "./Idiomas.vue?vue&type=template&id=9c416e5e&"
import script from "./Idiomas.vue?vue&type=script&lang=js&"
export * from "./Idiomas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports